import Box from "@mui/material/Box";
import React, { useState } from "react";
import * as am4charts from "@amcharts/amcharts4/charts";
import { ChartExportMenu } from "./charts/ChartExportMenu";
import Stack from "@mui/material/Stack";
import { TitleWithTooltipInfo } from "./charts/TitleWithTooltipInfo";
import { Typography } from "@mui/material";
import { ChartWrapperBorderColor } from "./charts/constants";
interface Props {
  id: string;
  chart: React.ReactNode;
  title: string;
  titleExtras?: React.ReactNode;
  noData?: boolean;
  chartRef?: React.RefObject<am4charts.XYChart | null>;
  csvFieldMappings?: Record<string, string>;
  tooltipTitle?: string;
  isLoading: boolean;
  /** Chart area height in px — override when a chart ranks more rows than fit
   * legibly at the default. */
  height?: number;
  /** Hides the export menu even when actions would otherwise show — the
   * public share page renders no export anywhere. */
  hideChartExport?: boolean;
}

export function ChartWrapper(props: Props) {
  const [isChartHovered, setIsChartHovered] = useState(false);
  const shouldShowActions = !props.noData && !props.isLoading;
  const height = props.height ?? 350;
  return (
    <Box
      bgcolor={props.noData ? "#edeff1" : "#fff"}
      padding="20px 19px 8px 20px"
      minHeight={height}
      borderRadius="10px"
      boxSizing="border-box"
      border={`1px solid ${ChartWrapperBorderColor}`}
      id={props.id}
      gap="10px"
      width="100%"
      minWidth={0}
      maxWidth="100%"
      onMouseEnter={() => setIsChartHovered(true)}
      onMouseLeave={() => setIsChartHovered(false)}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        minWidth={0}
        maxWidth="100%"
      >
        {props.tooltipTitle ? (
          <TitleWithTooltipInfo
            tooltipTitle={props.tooltipTitle}
            chartTitle={props.title}
            showInfoIcon={isChartHovered}
          />
        ) : (
          <Typography variant="h6" sx={{ minWidth: 0, flexShrink: 1 }}>
            {props.title}
          </Typography>
        )}
        {shouldShowActions && (
          <Stack
            direction="row"
            alignItems="center"
            ml="auto"
            flexShrink={0}
            minWidth={0}
            sx={{ flexWrap: "wrap", gap: 1 }}
          >
            {props.titleExtras && (
              <Box
                sx={{
                  minWidth: 0,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.5,
                }}
              >
                {props.titleExtras}
              </Box>
            )}
            {props.chartRef && !props.hideChartExport && (
              <ChartExportMenu
                chart={props.chartRef}
                title={props.title}
                csvFieldMappings={props.csvFieldMappings}
              />
            )}
          </Stack>
        )}
      </Box>
      <Box height={height}>{props.chart}</Box>
    </Box>
  );
}
